const PropTypes = require('prop-types');
const React = require('react');
const classNames = require('classnames');
const PayoutMethodOptions = require(
  'components/dashboard/selling/shop_policies/payout_method_options.jsx'
);
const { cmsPagePath } = require('components/shared/url_helpers.js');
const cmsPath = cmsPagePath('direct-checkout-faq#when-will-i-get-paid');

function DirectCheckoutProfileSetup(props) {
  function profileContainerClass() {
    return classNames(
      'dc_form margined-bottom',
      { 'global-slidedown--open': props.selected },
      { 'global-slidedown--closed': !props.selected }
    );
  }

  function firstOrderPayoutHtml() {
    return (
      I18n.t('js.shopPolicies.directCheckoutSetup.firstOrderPayoutHtml', {
        strongOpen: '<strong>',
        strongClose: '</strong>',
        lineBreak: '<br/>',
        linkOpen: `<a href="${cmsPath}" target="blank" class="muted underlined" tabindex="-1">`,
        linkClose: '</a>',
      })
    );
  }

  return (
    <div
      className={profileContainerClass()}
      data-direct-checkout-profile-form
    >
      <PayoutMethodOptions
        {...props}
        modularFormContainerClass="module"
        modularBankAccountFormClass="module module-gray"
      />
      <div className="module">
        <p
          className="fine-print tight-line-height mb-0"
          dangerouslySetInnerHTML={{ __html: firstOrderPayoutHtml() }}
        >
        </p>
      </div>
    </div>
  );
}

DirectCheckoutProfileSetup.propTypes = {
  profileAttributes: PropTypes.object.isRequired,
  payoutCurrencies: PropTypes.object.isRequired,
  bankLookupUrl: PropTypes.string.isRequired,
  hasLayawayEnabled: PropTypes.bool,
  countryCodeOptions: PropTypes.array.isRequired,
  formPrefix: PropTypes.string.isRequired,
  selected: PropTypes.bool,
  shopCurrency: PropTypes.string.isRequired,
  onCountryChange: PropTypes.func.isRequired,
  onCurrencyChange: PropTypes.func.isRequired,
};

module.exports = DirectCheckoutProfileSetup;



// WEBPACK FOOTER //
// ./javascripts/components/shop/direct_checkout_profile_setup.jsx